import { useCallback, useEffect, useState } from 'react';


const reloadPage = () => window.location.reload(true);

const versionFilePath = "/sp/version.json";

const fetchVersion = (requestStr) => {
    return fetch(requestStr)
        .then(res => res.json())
        .then(data => data.version)
        .catch(() => undefined);
};

const UpdateStatus = {
    checking: "checking",
    current: "current",
    updating: "updating",
    available: "available"
};

export const useUpdateCheck = ({ interval }) => {
    const [currentVersion, setCurrentVersion] = useState(undefined);
    const [status, setStatus] = useState(UpdateStatus.checking);

    useEffect(() => {
        fetchVersion(versionFilePath)
            .then(version => {
                if (version !== null) {
                    setCurrentVersion(version);
                }
            })
    }, []);

    const checkUpdate = useCallback(() => {
        if (typeof currentVersion === 'undefined') {
            setStatus(UpdateStatus.current);

            return;
        }

        setStatus(UpdateStatus.checking);

        fetchVersion(versionFilePath)
            .then(version => {
                if (version === currentVersion) {
                    setStatus(UpdateStatus.current);
                } else {
                    setStatus(UpdateStatus.available);
                }
            })
    }, [currentVersion]);

    useEffect(() => {
        checkUpdate();
    }, [checkUpdate]);

    useEffect(() => {
        if (status !== UpdateStatus.current) {
            return;
        }

        const timeoutId = setTimeout(
            () => checkUpdate(),
            interval || 10000,
        );

        return () => {
            clearTimeout(timeoutId);
        };

    }, [interval, status, checkUpdate]);

    return { status, reloadPage };
};